import {FormLabels, FormLabel} from '../../../../_legacy/Form/stores/Form';
import {Label} from '../../../../_legacy/Form/types';

export function serializeLabels(data): FormLabels {
    const lablesData = data?.Form[0]?.Labels;

    let labels: FormLabel[] = [];
    let selected: FormLabel;
    let label: string,
        lines: string,
        clean: string,
        mayprint: string,
        print = '';

    if (lablesData) {
        label = lablesData[0].label;
        lines = lablesData[0].wantslines;
        print = lablesData[0].wantsprint;
        clean = lablesData[0].wantsclean;
        mayprint = lablesData[0].mayprint;

        labels = lablesData.map((label: Label) => {
            return {
                label: label.labelname,
                value: label.label
            };
        });
    }

    return {
        labels,
        selected,
        label,
        lines,
        mayprint,
        clean,
        print
    };
}
